module.exports = __webpack_public_path__ + "media/images/icon__compete@3x-d458ec6626895d6395b25709c4d1e261.png";